// $(document).on('click', '#skip-upload', function() {
//         $('.ctm-product-form__submit').trigger('click'); 
//         $('.close_btn').trigger('click');
        
// });
document.getElementById('skip-upload').addEventListener('click', function() {
    if (!document.cookie.split('; ').find(row => row.startsWith('skipUpload='))) {
        console.log('JavaScript is running for the first time.');
        $('.ctm-product-form__submit').trigger('click'); 
        $('.close_btn').trigger('click');
         $('.close_btn_').trigger('click');
        document.cookie = "skipUpload=true; path=/; max-age=31536000"; // 1 year expiry
    } else {
        console.log('The JavaScript has already been executed.');
       $('.popup-container-1').css({
            'visibility': 'hidden',
            'opacity': '0',
            // 'transition': 'all 0.1s',
            'transform': 'scale(1.3)',
            'position': 'fixed'
        });
      $('.section-header.shopify-section-group-header-group').css({
                        'z-index': '3'
                    });
         $('body').css({
                        'overflow': 'auto'
                    });
      $('.ctm-product-form__submit').show(); 
       $('.ctm-add-to-cart-btn').hide(); 
       $('.ctm-product-form__submit').trigger('click'); 
    }
});
function removeSkipUploadCookie() {
    document.cookie = "skipUpload=; path=/; max-age=0"; // Expire the cookie immediately
}
$(document).on('click', '#upload-button_', function() {
        $('.close_btn_').trigger('click');
        $('#upload-file').trigger('click');
        
});
// js for color swaches
// money format
